/**
 * Breadcrumb refactor, for the time being called: SloppyBread
 */
import './SloppyBread.scss';

import * as React from 'react';

import {
  SlBreadcrumb,
  SlBreadcrumbItem,
} from '@shoelace-style/shoelace/dist/react';
import { translate } from '~l10n/client';
import cx from 'classnames';

import { IconButton } from '~shared/components/buttons';
import { IconChevron } from '~shared/components/icons/micro';
import { IconEllipsis } from '~shared/components/icons/standard';
import { LinkMenu } from '~shared/components/LinkMenu';

interface Props {
  max?: number;
  single?: boolean;
  crumbs: Crumb[];
  expand?: boolean;
  showBack?: boolean;
}
// example of crumbs
// const crumbs = [
//   { label: 'Personal', link: '/personal' },
//   { label: 'Social 30-1', link: '/personal/social-301' },
// ];
export const SloppyBread = ({ crumbs, showBack = false }: Props) => {
  if (crumbs.length <= 3) {
    return (
      <div className="sloppy-bread-container">
        <SlBreadcrumb className="flex-nowrap overflow-hidden">
          <div
            slot="separator"
            className="font-display font-500 text-base leading-12 flex-shrink-0"
          >
            /
          </div>
          {crumbs.map((crumb, index) => {
            const isLast = index === crumbs.length - 1;
            const isFirst = index === 0;
            const className = cx(
              { ['font-700']: isLast, ['font-500']: !isLast },
              'max-w-sm font-display text-cyan-700 hocus:text-cyan-600 no-underline text-display leading-12 truncate'
            );
            return (
              <SlBreadcrumbItem
                key={index}
                href={crumb.href}
                className="min-w-0"
              >
                {isFirst && showBack ? (
                  <div slot="prefix">
                    <IconChevron direction="left" />
                  </div>
                ) : null}
                <span className={className} title={crumb.label}>
                  {crumb.label}
                </span>
              </SlBreadcrumbItem>
            );
          })}
        </SlBreadcrumb>
      </div>
    );
  }

  const copy = [...crumbs];
  const current = copy.pop();
  const parent = copy.pop();
  const root = copy.shift();
  return (
    <div className="sloppy-bread-container">
      <SlBreadcrumb className="flex-nowrap overflow-hidden">
        <div
          slot="separator"
          className="font-display font-500 text-base leading-12 flex-shrink-0"
        >
          /
        </div>
        <SlBreadcrumbItem href={root.href} className="min-w-0">
          {showBack ? (
            <div slot="prefix" className="flex items-center h-12">
              <IconChevron direction="left" />
            </div>
          ) : null}
          <span
            className="max-w-sm font-display text-cyan-700 hocus:text-cyan-600 no-underline text-display leading-12 font-500 truncate"
            title={root.label}
          >
            {root.label}
          </span>
        </SlBreadcrumbItem>
        <SlBreadcrumbItem className="min-w-0">
          <div slot="suffix">
            <EllipsisMenu items={copy} />
          </div>
        </SlBreadcrumbItem>
        <SlBreadcrumbItem href={parent.href} className="min-w-0">
          <span
            className="max-w-sm font-display text-cyan-700 hocus:text-cyan-600 no-underline text-display leading-12 font-500 truncate"
            title={parent.label}
          >
            {parent.label}
          </span>
        </SlBreadcrumbItem>
        <SlBreadcrumbItem href={current.href} className="min-w-0">
          <span
            className="max-w-sm font-display text-cyan-700 hocus:text-cyan-600 no-underline text-display leading-12 font-700 truncate"
            title={current.label}
          >
            {current.label}
          </span>
        </SlBreadcrumbItem>
      </SlBreadcrumb>
    </div>
  );
};

interface EllipsisProps {
  items: Array<Crumb>;
}
const EllipsisMenu = ({ items }: EllipsisProps) => {
  return (
    <LinkMenu links={items} direction={'bottom-start'}>
      <IconButton aria-label={translate('menu popup')}>
        <IconEllipsis />
      </IconButton>
    </LinkMenu>
  );
};

export interface Crumb {
  label: string;
  href: string;
  test?: boolean;
}
